import { useState } from "react";
import { useStore, CAT_META } from "../store/Store";

// ─── SPLIT CARD ───────────────────────────────────────────────────────────────
// Card is diagonally split into a colored half and a white half — photo sits
// in the colored half, info in the white half. Bold geometric look, no other
// style in the set uses a diagonal division.
export default function SplitCard({ p, onNav, accent }) {
  const { dispatch, wish, toggleWish, notify } = useStore();
  const meta = CAT_META[p.category] || { emoji:"👗" };
  const disc = Math.round((1 - p.price / p.mrp) * 100);
  const wished = wish.includes(p.id);

  const addCart = (e) => {
    e.stopPropagation();
    dispatch({ type:"ADD", p:{ ...p, sc:p.colors?.[0]||"Default", ss:p.sizes?.[0]||"Free" } });
    notify(`${p.name} added!`);
    if (navigator.vibrate) navigator.vibrate(50);
  };

  return (
    <div onClick={()=>onNav("product", p.id)} style={{ borderRadius:16, overflow:"hidden", cursor:"pointer", position:"relative", background:"white", height:340, boxShadow:"0 8px 22px rgba(0,0,0,0.08)" }}>
      {/* Colored diagonal panel */}
      <div style={{ position:"absolute", inset:0, background:accent, clipPath:"polygon(0 0, 100% 0, 100% 62%, 0 78%)" }}/>

      <div style={{ position:"relative", height:200, display:"flex", alignItems:"center", justifyContent:"center", padding:"18px 18px 0" }}>
        {p.img
          ? <img src={p.img} alt={p.name} style={{ width:"100%", height:"100%", objectFit:"contain" }} loading="lazy"/>
          : <div style={{ fontSize:50, opacity:0.3, color:"white" }}>{meta.emoji}</div>
        }
        {disc > 0 && (
          <span style={{ position:"absolute", top:14, right:14, background:"white", color:accent, fontSize:10, fontWeight:800, padding:"4px 10px", borderRadius:20 }}>
            {disc}% OFF
          </span>
        )}
        <button onClick={e=>{ e.stopPropagation(); toggleWish(p.id); if(navigator.vibrate)navigator.vibrate(30); }}
          style={{ position:"absolute", top:14, left:14, background:"rgba(255,255,255,0.9)", border:"none", borderRadius:"50%", width:28, height:28, fontSize:13, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}>
          {wished ? "❤️" : "🤍"}
        </button>
      </div>

      <div style={{ position:"relative", padding:"18px 18px 20px" }}>
        <div style={{ fontSize:9, color:accent, fontWeight:700, letterSpacing:1.5, textTransform:"uppercase", marginBottom:4 }}>{p.category}</div>
        <div style={{ fontWeight:700, fontSize:14, color:"#1a1a2e", marginBottom:8, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{p.name}</div>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <span style={{ fontSize:16, fontWeight:900, color:"#1a1a2e" }}>₹{p.price?.toLocaleString("en-IN")}</span>
          {p.stock > 0 && (
            <button onClick={addCart} style={{ background:accent, color:"white", border:"none", padding:"7px 15px", borderRadius:20, fontSize:10.5, fontWeight:800, cursor:"pointer" }}>+ Add</button>
          )}
        </div>
      </div>
    </div>
  );
}
